module.exports = __webpack_public_path__ + "img/become2.7ec12c03.png";